module.exports = __webpack_public_path__ + "static/media/nuez.977b3acc.webp";